export const SOCIAL_USER_INFO_KEY = "social_user_info";
export const SOCIAL_USER_INFO_UPDATED_EVENT = "social_user_info_updated";

export const getSocialUserInfo = () => {
    try {
        const raw = localStorage.getItem(SOCIAL_USER_INFO_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        console.error("Error parsing social user info:", error);
        return null;
    }
};

export const notifySocialUserInfoUpdated = (userinfo) => {
    if (typeof window === "undefined") return;

    window.dispatchEvent(
        new CustomEvent(SOCIAL_USER_INFO_UPDATED_EVENT, {
            detail: userinfo,
        })
    );
};

export const setSocialUserInfo = (userinfo) => {
    if (!userinfo) return userinfo;

    localStorage.setItem(SOCIAL_USER_INFO_KEY, JSON.stringify(userinfo));
    notifySocialUserInfoUpdated(userinfo);

    return userinfo;
};
